<template>
  <div>
    <div>
      <v-breadcrumbs
        class="px-0"
        :items="[
          { title: '出欠管理', href: '/attendance/list', color: 'primary' },
          { title: '登園・降園' },
        ]"
      ></v-breadcrumbs>
    </div>
    <div>
      <h3>登園・降園</h3>
    </div>

    <v-row class="mt-5">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
    </v-row>

    <v-dialog v-model="dialog" width="620px">
      <v-card>
        <v-card-title>{{
          selectedChild ? selectedChild.lastName + selectedChild.firstName : ""
        }}</v-card-title>

        <v-card-text>
          <v-container class="py-8">
            <v-row>
              <v-col cols="12">
                <h5>兄弟設定</h5>
              </v-col>
            </v-row>
            <v-row
              v-for="(siblingItem, i) in selectedChildsSiblingAttendance"
              :key="i"
            >
              <v-col cols="6">
                {{
                  siblingItem.child.lastName + "" + siblingItem.child.firstName
                }}
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="attend(String(siblingItem.child.childId))"
                  :disabled="
                    isUpdating || isAttended(siblingItem.child.childId)
                  "
                  small
                  color="primary"
                  variant="flat"
                  class="custom-disabled-btn"
                >
                  登園<br />{{ getAttendedTime(siblingItem.child.childId) }}
                </v-btn>
                <v-btn
                  @click="left(String(siblingItem.child.childId))"
                  :disabled="
                    isUpdating ||
                    isLeft(siblingItem.child.childId) ||
                    !isAttended(siblingItem.child.childId)
                  "
                  class="ml-4 custom-disabled-btn"
                  small
                  color="secondary"
                  variant="flat"
                >
                  降園<br />{{ getLeftTime(siblingItem.child.childId) }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="pt-8">
              <v-col cols="6">
                <v-btn
                  :disabled="!shouldAttendButtonEnabled"
                  @click="attend(String(selectedChild?.childId))"
                  color="primary"
                  block
                  style="height: 18vh; font-size: 1.8rem"
                  class="custom-disabled-btn"
                  >登園<br />{{
                    selectedChild ? getAttendedTime(selectedChild.childId) : ""
                  }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  :disabled="
                    !shouldLeftButtonEnabled || shouldAttendButtonEnabled
                  "
                  @click="left(String(selectedChild?.childId))"
                  color="secondary"
                  block
                  class="custom-disabled-btn"
                  style="height: 18vh; font-size: 1.8rem; color: white !important;"
                  >降園<br/>{{
                    selectedChild ? getLeftTime(selectedChild.childId) : ""
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <div>
            <v-progress-linear
              v-if="isUpdating"
              indeterminate
              color="primary"
              class="my-8"
            ></v-progress-linear>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn @click="() => (dialog = false)" variant="text"color="grey"
            >閉じる</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container fluid class="mt-10">
      <v-row style="height: 100vh">
        <v-col cols="9" align-self="center" style="height: 100vh">
          <kana-list :kanaArray="kanaList" @kana-clicked="clickKana"></kana-list>
        </v-col>
        <v-col cols="3">
          <v-list nav bg-color="primary" class="child-list">
            
            <v-list-subheader class="text-white font-weight-bold">園児</v-list-subheader>
            <v-divider 
              color="white" 
              thickness="1" 
              class="opacity-100"
            ></v-divider>
            
            <v-list-item 
              v-for="item in childrenList" 
              :key="item.childId" 
              link 
              @click="clickChild(item as NurseryChildResponse)"
            >
              <v-list-item-title class="text-white font-weight-bold">
                {{ item.lastName + item.firstName }}
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import KanaList from "@/components/atoms/KanaList.vue";
import LocalDataService from "@/service/LocalDataService";
import { childrenModule } from "@/store/dataModules/childrenModule";
import { attendanceModule } from "@/store/dataModules/attendanceModule";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import {
  ChildResponse,
  NurseryAttendanceResponse,
  NurseryChildResponse,
} from "chaild-api/lib";
import { ChildForAttendance } from "@/api/ApiChildren";

interface DataType {
  dialog: boolean;
  selectedChild: ChildResponse | null;
  selectedKana: string | null;

  isUpdating: boolean;
  loading: boolean;
}

export default defineComponent({
  name: "AttendanceManagement",

  components: {
    KanaList,
  },

  async mounted() {
    attendanceModule.setDate(dayjs().format("YYYY-MM-DD"));
    await this.listDailyAttendances();
    await this.fetchKanaList();
  },

  // 押したひらがなに応じて変化させる

  data: (): DataType => {
    return {
      dialog: false,
      selectedChild: null,
      selectedKana: null,

      isUpdating: false,
      loading: false,
    };
  },

  computed: {
    childrenList(): ChildForAttendance[] {
      if (this.selectedKana) {
        const target = childrenModule.kanaList.filter(
          (childrenWithKana) => childrenWithKana.value === this.selectedKana
        );
        return target.flatMap((childrenWithKana) => childrenWithKana.children);
      }

      return [];

      // return childrenModule.kanaList.flatMap((childrenWithKana) => childrenWithKana.children);
    },
    kanaList: function () {
      const items = childrenModule.kanaList.map((item) => {
        if ((item as any).children.length > 0) {
          return (item as any).value;
        }
      });
      return items.filter((item) => item);
    },
    selectedChildAttendance(): NurseryAttendanceResponse | null {
      if (this.selectedChild) {
        const find = attendanceModule.todaysAttendances.find(
          (at) => at.child.childId === this.selectedChild?.childId
        );
        if (find) {
          return find;
        }
      }
      return null;
    },
    selectedChildsSiblingAttendance(): NurseryAttendanceResponse[] {
      const result: NurseryAttendanceResponse[] = [];
      if (
        this.selectedChild &&
        this.selectedChildAttendance &&
        attendanceModule.todaysAttendances
      ) {
        const siblingChildIds =
          this.selectedChildAttendance.child.siblingChildIds;
        // Todo: 以下消す
        // const siblingChildIds = [258888588688,278888588888]

        for (const id of siblingChildIds) {
          const _attendance = attendanceModule.todaysAttendances.find((at) => {
            if (at.child.childId == id) {
              return at;
            }
          });
          if (_attendance) {
            result.push(_attendance);
          }
        }
      }
      return result;
    },
    shouldAttendButtonEnabled(): boolean {
      if (this.isUpdating) {
        return false;
      }
      if (
        this.selectedChildAttendance &&
        this.selectedChildAttendance.attendedAt
      ) {
        return false;
      }
      return true;
    },
    shouldLeftButtonEnabled(): boolean {
      if (this.isUpdating) {
        return false;
      }
      if (this.selectedChildAttendance && this.selectedChildAttendance.leftAt) {
        return false;
      }
      return true;
    },
    getAttendedTime: function () {
      return function (childId?: number): string {
        if (childId) {
          const attendance = attendanceModule.todaysAttendances.find(
            (at) => at.child.childId == childId
          );
          if (attendance && attendance.attendedAt) {
            return dayjs(attendance.attendedAt).format("HH:mm");
          }
        }
        return "";
      };
    },
    getLeftTime: function () {
      return function (childId?: number): string {
        if (childId) {
          const attendance = attendanceModule.todaysAttendances.find(
            (at) => at.child.childId == childId
          );
          if (attendance && attendance.leftAt) {
            return dayjs(attendance.leftAt).format("HH:mm");
          }
        }
        return "";
      };
    },
  },

  methods: {
    async fetchKanaList() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await childrenModule.listKana({
          nurseryId: nurseryId,
        });
      }
      this.loading = false;
    },
    async listDailyAttendances() {
      await attendanceModule.listTodaysAttendances();
    },
    clickKana(value: string) {
      this.selectedKana = value;
    },
    clickChild(value: NurseryChildResponse) {
      this.selectedChild = value;
      this.dialog = true;
    },
    async attend(childId: string) {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && childId) {
        this.isUpdating = true;
        const response = await attendanceModule
          .createAttendance({
            childId: childId,
            nurseryId: nurseryId,
            attendedAt: this.getNow(),
          })
          .catch();
        if (response) {
          Swal.fire({
            title: "登園しました",
            icon: "success",
            toast: true,
            position: "top-end",
            timer: 1000,
          });
          window.setTimeout(() => {
            this.dialog = false;
          }, 5000);
          await this.listDailyAttendances();
        }
        this.selectedKana = null;
        this.isUpdating = false;
      }
    },
    async left(childId: string) {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && childId) {
        this.isUpdating = true;
        const response = await attendanceModule
          .createAttendance({
            childId: childId,
            nurseryId: nurseryId,
            leftAt: this.getNow(),
          })
          .catch();
        if (response) {
          Swal.fire({
            title: "降園しました",
            icon: "success",
            toast: true,
            position: "top-end",
            timer: 1000,
          });
          window.setTimeout(() => {
            this.dialog = false;
          }, 5000);
          await this.listDailyAttendances();
        }
        this.selectedKana = null;
        this.isUpdating = false;
      }
    },
    getNow(): string {
      return dayjs().format();
    },
    isAttended(childId: number): boolean {
      const result = attendanceModule.todaysAttendances.find((at) => {
        if (at.child.childId == childId && at.attendedAt != null) {
          return at;
        }
      });
      return result != null ? true : false;
    },
    isLeft(childId: number): boolean {
      const result = attendanceModule.todaysAttendances.find((at) => {
        if (at.child.childId == childId && at.leftAt != null) {
          return at;
        }
      });
      return result != null ? true : false;
    },
  },
});
</script>
<style scoped>
/* disabled（非活性）になった時だけ、強制的にグレーに塗りつぶす */
.custom-disabled-btn.v-btn--disabled {
  background-color: #9e9e9e !important; /* お好みのグレーのカラーコード */
  color: #ffffff !important; /* 文字色は白に固定 */
  opacity: 1 !important; /* Vuetify特有の「半透明になる」のを打ち消す */
}

.child-list {
  height: 50vh;
  overflow-y: scroll;
}

/* スクロールバーを常に表示 */
.child-list::-webkit-scrollbar {
  width: 20px;
}
.child-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 6px;
}
.child-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  border: 2px solid rgba(0, 0, 0, 0.15);
}
.child-list::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
</style>
